import { makeStyles } from '@material-ui/core';
import { Skeleton } from '@mui/material';
import React from 'react';

import { Copy } from 'src/common/ui/components';
import useTypedSWR from 'src/components/general/useTypedSWR';
import { GET_ID_IMAGE_URL } from 'src/idVerification/queries/getIdImageUrl.gql';

const IMAGE_HEIGHT = 600;
const IMAGE_WIDTH = IMAGE_HEIGHT;

const IdImage = ({ imageId }: { imageId: string }) => {
  const { data, isLoading } = useTypedSWR([GET_ID_IMAGE_URL, { imageId }], {
    revalidateOnFocus: false,
  });

  if (isLoading) {
    return <Skeleton variant="rectangular" height={IMAGE_HEIGHT} width={IMAGE_WIDTH} />;
  }

  return (
    <img
      src={data?.chartDocument?.file?.url ?? ''}
      style={{ maxHeight: IMAGE_HEIGHT, maxWidth: '100%', objectFit: 'contain' }}
      key={imageId}
    />
  );
};

export const IdImageSet = ({ imageIds }: { imageIds: string[] | null }) => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      {imageIds?.length ? (
        imageIds.map((imageId, index) => (
          <div className={styles.imageWrapper} key={imageId}>
            <IdImage imageId={imageId} />
            <div className={styles.imageLabel}>ID Image {index + 1}</div>
          </div>
        ))
      ) : (
        <Copy variant="body1">No images available</Copy>
      )}
    </div>
  );
};

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    marginBottom: 24,
  },
  imageWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 8,
  },
  imageLabel: {
    fontFamily: 'Nunito Sans',
    fontSize: 14,
    color: '#5F5F5F',
  },
});
